module.exports = __webpack_public_path__ + "img/givens-line-long.fc671737.svg";